import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import useNavigateToPage from '@/hooks/useNavigateToPage';
import { useRewardCardAccount } from '@/hooks/useRewardCards';
import PersonContext from '@/pages/Person/PersonContext';
import RewardCardItem from '@/pages/RewardCardList/components/RewardCardItem';
import Container from '@/ui/components/Container';
import Spinner from '@/ui/components/Spinner';

const RewardCardAccountView = () => {
  const {
    person: { id: personId }
  } = useContext(PersonContext);
  const { rewardCardAccountId } = useParams();
  const { data: rewardCardAccountResponse, isPending: isLoadingRewardCardAccount } =
    useRewardCardAccount(rewardCardAccountId as string);
  const { navigateToRewardCards } = useNavigateToPage();

  return (
    <Container type="page">
      <div className="inline-flex">
        <button
          className="w-6 inline-block text-center"
          onClick={() => navigateToRewardCards(personId)}
          type="button">
          <FontAwesomeIcon icon={faChevronLeft} className="mr-1 text-xl" />
        </button>
        <PageHeader headingText={'Reward Card Account View'} />
      </div>

      {isLoadingRewardCardAccount ? (
        <div>
          <Spinner />
        </div>
      ) : rewardCardAccountResponse?.data ? (
        <RewardCardItem
          rewardCardAccount={rewardCardAccountResponse.data}
          hasCurrentActiveCard={false}
        />
      ) : (
        <p>Account not found</p>
      )}
    </Container>
  );
};

export default RewardCardAccountView;
